<div class="px-3 flex-auto gap-0.5 w-full flex flex-col justify-center pb-7">
	<div class="gap-3 h-full flex flex-col justify-center">
		<div class="text-warn">
			<ng-content select="[image]"></ng-content>
		</div>
		<div class="text-h1 font-bold">
			<ng-content select="[title]"></ng-content>
		</div>
		<div class="text-body1">
			<ng-content></ng-content>
		</div>
	</div>
</div>
<div
	class="px-3 pt-1 pb-3 gap-1 w-full flex sticky flex-row items-end animate-[options-fade-in_600ms_300ms_ease-in-out_forwards] reach-warning-options bottom-0"
>
	<ng-container [ngTemplateOutlet]="options"></ng-container>
</div>
<ng-template #options>
	<ng-content select="[options]"></ng-content>
</ng-template>
